/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProximityZone } from './ProximityZone';
import {
    ProximityZoneFromJSON,
    ProximityZoneFromJSONTyped,
    ProximityZoneToJSON,
    ProximityZoneToJSONTyped,
} from './ProximityZone';

/**
 * This type represents a violation event triggered between a vehicle and a stationary unit.
 * @export
 * @interface StationaryUnitZoneViolationEvent
 */
export interface StationaryUnitZoneViolationEvent {
    /**
     * Unique ID for this event.
     * 
     * The ID is specified by the client to allow for indempotent submission of offline events. See the "Offline Synchronization" page in our documentation.
     * @type {string}
     * @memberof StationaryUnitZoneViolationEvent
     */
    id: string;
    /**
     * Time at which the event was reported to the backend.
     * 
     * For the time at which the event actually occurred, see the `time` field.
     * @type {Date}
     * @memberof StationaryUnitZoneViolationEvent
     */
    createdAt: Date;
    /**
     * Time at which the device recorded the event.
     * @type {Date}
     * @memberof StationaryUnitZoneViolationEvent
     */
    time: Date;
    /**
     * Vehicle that triggered this event.
     * @type {string}
     * @memberof StationaryUnitZoneViolationEvent
     */
    vehicleId: string;
    /**
     * Stationary unit that triggered this event.
     * @type {string}
     * @memberof StationaryUnitZoneViolationEvent
     */
    stationaryUnitId: string;
    /**
     * User that was logged in at the time the event occurred.
     * @type {string}
     * @memberof StationaryUnitZoneViolationEvent
     */
    userId?: string | null;
    /**
     * Minimum distance between the two devices in centimeters.
     * @type {number}
     * @memberof StationaryUnitZoneViolationEvent
     */
    minimumDistanceCm: number;
    /**
     * ELOshield zone which was violated.
     * @type {ProximityZone}
     * @memberof StationaryUnitZoneViolationEvent
     */
    triggeredZone: ProximityZone;
}



/**
 * Check if a given object implements the StationaryUnitZoneViolationEvent interface.
 */
export function instanceOfStationaryUnitZoneViolationEvent(value: object): value is StationaryUnitZoneViolationEvent {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('stationaryUnitId' in value) || value['stationaryUnitId'] === undefined) return false;
    if (!('minimumDistanceCm' in value) || value['minimumDistanceCm'] === undefined) return false;
    if (!('triggeredZone' in value) || value['triggeredZone'] === undefined) return false;
    return true;
}

export function StationaryUnitZoneViolationEventFromJSON(json: any): StationaryUnitZoneViolationEvent {
    return StationaryUnitZoneViolationEventFromJSONTyped(json, false);
}

export function StationaryUnitZoneViolationEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationaryUnitZoneViolationEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'time': (new Date(json['time'])),
        'vehicleId': json['vehicleId'],
        'stationaryUnitId': json['stationaryUnitId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'minimumDistanceCm': json['minimumDistanceCm'],
        'triggeredZone': ProximityZoneFromJSON(json['triggeredZone']),
    };
}

export function StationaryUnitZoneViolationEventToJSON(json: any): StationaryUnitZoneViolationEvent {
    return StationaryUnitZoneViolationEventToJSONTyped(json, false);
}

export function StationaryUnitZoneViolationEventToJSONTyped(value?: StationaryUnitZoneViolationEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'time': value['time'].toISOString(),
        'vehicleId': value['vehicleId'],
        'stationaryUnitId': value['stationaryUnitId'],
        'userId': value['userId'],
        'minimumDistanceCm': value['minimumDistanceCm'],
        'triggeredZone': ProximityZoneToJSON(value['triggeredZone']),
    };
}

